export const defaultSections = [
  {
    id: 1,
    title: "वैयक्तिक माहिती",
    fields: [
      { id: 1, label: "नाव", value: "नाव  भरा" },
      { id: 2, label: "जन्मतारीख", value: "जन्मतारीख भरा" },
      { id: 3, label: "जन्म वेळ", value: "जन्म वेळ जन्मतारीख भरा" },
      { id: 4, label: "जन्मस्थान", value: "जन्मस्थान भरा" },
      { id: 5, label: "शिक्षण", value: "शिक्षण भरा" },
      { id: 6, label: "व्यवसाय", value: "व्यवसाय भरा" },
      { id: 7, label: "उत्पन्न", value: "उत्पन्न भरा" }
    ]
  },
  {
    id: 2,
    title: "कुटुंबातील सदस्य",
    fields: [
      { id: 8, label: "वडिलांचे नाव", value: "वडिलांचे नाव प्रविष्ट करा" },
      { id: 9, label: "वडिलांचा व्यवसाय", value: "वडिलांचा व्यवसाय भरा" },
      { id: 10, label: "आईचे नाव", value: "आईचे नाव भरा" },
      { id: 11, label: "आईचा व्यवसाय", value: "आईचा व्यवसाय भरा" }
    ]
  },
  {
    id: 3,
    title: "संपर्क व्यक्ती",
    fields: [
      { id: 12, label: "नाव", value: "नाव  भरा" },
      { id: 13, label: "फोन नंबर", value: "फोन नंबर  भरा" },
      { id: 14, label: "पत्ता", value: "पत्ता भरा" }
    ]
  }
];